<template>
  <footer class="bg-brand-950 text-brand-100 py-10 border-t border-accent-500/60 shadow-md">
    <div class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row md:justify-between items-center">
      <div class="mb-4 md:mb-0 text-center md:text-left">
        <p class="text-sm">
          Issues while using the tool? Contact us at:
          <a
            href="mailto:support@teopm.com"
            class="text-accent-400 hover:text-accent-300 transition-colors underline"
          >
            support@teopm.com
          </a>
        </p>
      </div>
      <div class="text-center md:text-right">
        <p class="text-xs text-brand-300">
          © 2026. All rights reserved.
        </p>
        <p class="text-xs text-brand-400">
          Powered by TEOPM
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {};
</script>